/* eslint-disable react/jsx-key */
"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";
import FirstBlockAbout from "@/components/common/FirstBlockAbout";

export default function Lipiecmeats() {
  const primaryColor = "#D11313";
  useEffect(() => {
    // Dynamically add the Google font to the document head
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link); // Cleanup on unmount
    };
  }, []);

  return (
    <>
      <section className="flex flex-col gap-[100px] my-[35px]">
        <div>
          <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FLipiec%20Meats%2Flipiecmeats%20logo.webp?alt=media&token=5a0f848a-cdf9-4516-a9de-9b7514461b5b" />
          <FirstBlockAbout
            media={{
              type: "image",
              src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FLipiec%20Meats%2Flipiecmeatsbackground.webp?alt=media&token=fd0bfcb5-4e48-4087-84bf-881cb63b655e",
            }}
            primaryColor={primaryColor}
          />
          <WebsiteSubtitle
            text="For Lipiec Meats, purveyors of traditional Polish and Ukrainian cuisine and fresh meats in the GTA, we orchestrated their entire online debut. This comprehensive project began with establishing their brand identity through a custom logo and website design. We then developed a bespoke WordPress theme tailored to their unique offerings, including a full product upload to launch their online store. To build their digital footprint and engage customers, we created compelling articles and managed their online advertising. Crucially, strategic SEO work was implemented to ensure Lipiec Meats could be easily discovered by those seeking high-quality, traditional meat products, effectively launching their full online appearance."
            title="Deliverables"
            tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
            buttonHref="https://lipiecmeats.ca/"
          />
        </div>

        <PortfolioTypography
          typographyData={[
            {
              headline:
                "Delve into a world of exceptional flavors with Lipec's exclusive range of premium meat products.",
              fontFamily: "Montserrat",
              fontSize: "40px",
              letterSpacing: "0%",
              lineHeight: "auto",
              textColor: "#010626",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioColorscheme
          ColorschemeData={[
            {
              title: "Main color",
              color: "#D11313",
              rgb: "#D11313",
              textColor: "#FFFFFF",
            },
            {
              title: "White",
              color: "#FFFFFF",
              rgb: "#FFFFFF",
              textColor: "#2c2d2c",
            },
            {
              title: "Black",
              color: "#2C2D2C",
              rgb: "#2C2D2C",
              textColor: "#FFFFFF",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioResponsiveDisplays
          ResponsiveDisplaysData={[
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FLipiec%20Meats%2Flipiecpc.webp?alt=media&token=d423a42e-f95f-42cf-9b61-9e06f91fc096",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FLipiec%20Meats%2Flipiecipad.webp?alt=media&token=8cb54111-c406-47d3-ae40-9e5d3cc60983",
            },
            {
              type: "image",
              content:
                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FLipiec%20Meats%2Flipiecmobile.webp?alt=media&token=1d1b870a-4afc-4583-bfc7-1cc101942fae",
            },
          ]}
          primaryColor={primaryColor}
        />
        <PortfolioTechStack
          primaryColor={primaryColor}
          blocks={[
            {
              title: "Design",
              icons: [<FigmaLogo />],
              opacity: 5,
            },
            {
              title: "Layout Development",
              icons: [<HTML5Logo />, <CSS3Logo />, <JSLogo />],
              opacity: 15,
            },
            {
              title: "Theme Development",
              icons: [<PHPLogo />],
              opacity: 25,
            },
            {
              title: "Publishing",
              icons: [
<WordpressLogo />
              ],
              opacity: 30,
            },
          ]}
        />
      </section>
    </>
  );
}
